var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb mb-0"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":{ name: 'StartPage' }}},[_vm._v("Home")])],1),_vm._v(" "),_vm._l((_vm.validList),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[_c('span',{staticClass:"active text-capitalize"},[_vm._v(_vm._s(item.replace('-', ' ').replace('-', ' ')))])])})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7ea1f32","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/layout/Breadcrumb.vue
// module id = null
// module chunks = 